// extracted by mini-css-extract-plugin
export default {"sub-text":"d6daeb","banner-content":"ac7200","message-bar":"acbb8d","message-bar__content":"ff5cc8"};